import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../../stores/auth-store';

interface RequireSuperAdminProps {
  children: React.ReactNode;
}

/**
 * Route-level guard for the Tracx platform admin surface (/platform/*).
 * Redirects to /login if unauthenticated, or /dashboard if the user is
 * authenticated but not a super_admin.
 */
export function RequireSuperAdmin({ children }: RequireSuperAdminProps) {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== 'super_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
